export default Object.freeze({
    APP_NAME: 'Cryptomas',
    WEBSITE_URL: 'merrycryptomas.com',
    WEBSITE_SHORT_URL: 'cryptomas.cards',
});
